export default __webpack_public_path__ + "static/media/battery-power-low.7812bfd6.svg";